/**
 * Definición de las propiedades comunes.
 * Estás definiciones deben coincidir con la declaración en WebKeys.java
 */
enum WebKeys {
  TOKEN_SEPARATOR = ".",

  COOKIES_FONT_SCALE = "fontScale",
  COOKIES_POLICY_ACCEPTED_COOKIE = "cpa",
  COOKIES_POLICY_MARKETING_COOKIE = "cpa-mrk",

  SESSION_TOKEN_COOKIE = "sessionToken",
  TIMEOUT_TOKEN_COOKIE = "timeoutToken",
  SALES_PHASE_TOKEN_COOKIE = "salesToken",

  PAYMENT_CLOSE_TOKEN = "cl",
  PAYMENT_OPERATIVE_TOKEN = "op",

  USER_TOKEN_COOKIE = "utk",
  USER_TOKEN_HEADER = "X-USER-TK",
  USER_TOKEN_PARAM = "UTK",
}

export default WebKeys;
